import { NgModule } from '@angular/core';
import { RichHtmlComponent } from '../components/rich-html.component';
import { FormsModule } from '@angular/forms';


@NgModule({
  declarations: [
    RichHtmlComponent
    
  ],
  imports:[
    FormsModule

  ],
  exports:[
  
    RichHtmlComponent  ]
})
export class RichHtmlModule { }
